const plannerComponentTypesEnum = Object.freeze({
  activity: 'activity',
  repeater: 'repeater',
});

const inputTypesEnum = Object.freeze({
  distance: 'distance',
  duration: 'duration',
});

const distanceOrDurationUnitsEnum = Object.freeze({
  meters: 'meters',
  kilometers: 'kilometers',
  miles: 'miles',
  yards: 'yards',
  seconds: 'seconds',
  minutes: 'minutes',
  hours: 'hours',
});

const zoneEnum = Object.freeze({
  zone1: 1,
  zone2: 2,
  zone3: 3,
  zone4: 4,
  zone5: 5,
  zone6: 6,
  zone7: 7,
});


export default plannerComponentTypesEnum;

export {
  plannerComponentTypesEnum,
  inputTypesEnum,
  distanceOrDurationUnitsEnum,
  zoneEnum,
};
